// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__29ozU","header":"MessagesList_header__2dvhM","chat":"MessagesList_chat__22UpT"};